import type { IntrinsicSystemProps, MotionPropsFor } from '@hover/blueprint';
import { motion } from '@hover/blueprint';
import { AnimatePresence, MotionConfig } from 'framer-motion';
import React from 'react';

import { useFullscreenTransition } from './helpers';

interface FullscreenImageExitBackgroundProps
  extends MotionPropsFor<IntrinsicSystemProps<'div'>> {
  isVisible?: boolean;
}

/**
 * Background to fade out when exiting view fullscreen view.
 *
 * @remarks When exiting fullscreen, the layout animation is applied to the
 * `FullscreenThumbnail` that sits in the list. In order to keep it above the
 * fading dark background, we need to render a separate element behind the
 * thumbnail as its animating back.
 */
const FullscreenImageExitBackground = ({
  isVisible,
  ...props
}: FullscreenImageExitBackgroundProps) => {
  const transition = useFullscreenTransition();

  return (
    <MotionConfig transition={transition}>
      <AnimatePresence>
        {isVisible && (
          <motion.div
            bg="neutral.900"
            bottom={0}
            exit={{ opacity: 0 }}
            left={0}
            margin="0 !important"
            opacity={1}
            position="fixed"
            right={0}
            top={0}
            {...props}
          />
        )}
      </AnimatePresence>
    </MotionConfig>
  );
};

export { FullscreenImageExitBackground };
